<template>
  <main class="account-main">
    <div class="form">
      <h1 class="text-phaneroo-400 text-3xl font-bold">Forgot Password?</h1>
      <form class="form my-8">
        <!-- TODO: add validation with Vuelidate -->
        <p class="font-medium mb-4">Enter the email address you used when you joined and we’ll send you instructions to reset your password.</p>
        <p class="font-medium mb-4">For security reasons, we do NOT store your password. So rest assured that we will never send your password via email.</p>
        <b-field label="Email">
          <b-input
            v-model="email"
            type="email"
            placeholder=""
            maxlength="30"
          />
        </b-field>
        <b-button
          type="is-primary"
          icon-left="paper-plane"
        >
          Submit
        </b-button>
      </form>
    </div>
  </main>
</template>

<script>
export default {
  name: 'ForgotPassword',
  data () {
    return {
      email: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.account-main {
  @apply flex flex-col justify-center items-center;
  min-height: calc(100vh - 52px);

  .form {
    width: 400px;
  }
}

@media(max-width: 768px) {
  .account-main {
    .form {
      width: 300px;
    }
  }
}
</style>
